import {
	GTMLink,
	type Props as GTMLinkProps,
} from 'components/controls/links/GTMLink';
import styles from './redundant-link.module.scss';

//For redundant links we want to remove from the tab order.
const RedundantLink = ({ href, ...restProps }: GTMLinkProps) => {
	if (!href) {
		return null;
	}
	return (
		<GTMLink
			className={styles.redundantlink}
			aria-hidden="true"
			tabIndex={-1}
			href={href}
			{...restProps}
		/>
	);
};

export default RedundantLink;
